import { useEffect } from 'react';
import { shell } from '@frontend/shell-utils';
import { usePreferenceStore } from '../store/store';
import { updatePreferenceValue } from './use-preference';

const handleGetRequest = () => {
  const currentState = usePreferenceStore.getState();
  if (shell.emit) {
    shell.emit('user-preferences:send-to-notification', currentState.prefs);
  }
};

const handlePreferenceSet = (_: any, payload: { id: string; value: any; updatedAt: string }) => {
  updatePreferenceValue(payload.id as any, payload.value, payload.updatedAt);
};

export const useUserPreferencesSync = () => {
  useEffect(() => {
    if (!shell.isShell || shell?.context !== 'alerts') return;

    const unsubscribe = usePreferenceStore.subscribe(
      (state) => state.prefs,
      (prefs) => {
        shell?.emit?.('user-preferences:send-to-notification', prefs);
      }
    );

    shell?.on?.('user-preferences:set', handlePreferenceSet);
    shell?.on?.('user-preferences:get', handleGetRequest);

    return () => {
      unsubscribe();
      shell?.off?.('user-preferences:set', handlePreferenceSet);
      shell?.off?.('user-preferences:get', handleGetRequest);
    };
  }, []);
};

export const UserPreferencesSync: React.FC = () => {
  useUserPreferencesSync();
  return null;
};
